import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Tabs } from '@factorialco/deprecated-design-system'
import { AtsInsightsPageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { useAtsInsightsFeatureAvailability } from 'modules/ats/lib/utils/insights'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { MainMetrics } from './MainMetrics'
import { MetricsFiltersProvider } from './MetricsFiltersProvider'
import { ParityMetrics } from './ParityMetrics'
import { SourcesMetrics } from './SourcesMetrics'

const InsightsPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { loading: loadingAvailability, hasInsightsAvailable } = useAtsInsightsFeatureAvailability()
  // TODO: Use routes for this
  const [currentTab, setCurrentTab] = useState('main-metrics')
  const setTab = (tabName: string) => setCurrentTab(tabName)

  const { data, loading } = useQuery(AtsInsightsPageDocument)

  const atsCompanyId: number | undefined = data?.ats?.companiesConnection?.nodes?.[0]?.id

  // TODO: Move this check to the route loader
  useEffect(() => {
    if (loadingAvailability) {
      return
    }

    if (!hasInsightsAvailable) {
      navigate(navigation.ats.fullPath())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atsCompanyId, loadingAvailability])

  const jobsForAccess = data?.ats?.jobPostingsConnection?.nodes?.filter(
    (job) => job._policies?.manage.can
  )

  return (
    <ResponsivePage.Body
      error={null}
      loading={loading || loadingAvailability}
      variant="wide"
      header={{
        title: i18n.t('ats.insights_page.title'),
        description: i18n.t('ats.insights_page.description'),
        illustration: 'user-interaction-review_chart',
      }}
    >
      {atsCompanyId && jobsForAccess && (
        <MetricsFiltersProvider>
          <Tabs currentId={currentTab} onTabClicked={setTab} key="analytics">
            <Tabs.Tab id="main-metrics" label={i18n.t('ats.insights_page.main_metrics.title')}>
              <MainMetrics atsCompanyId={atsCompanyId} jobs={jobsForAccess} />
            </Tabs.Tab>
            <Tabs.Tab
              id="sources-metrics"
              label={i18n.t('ats.insights_page.sources_metrics.title')}
            >
              <SourcesMetrics atsCompanyId={atsCompanyId} jobs={jobsForAccess} />
            </Tabs.Tab>
            <Tabs.Tab
              id="parity-metrics"
              label={i18n.t('ats.insights_page.parity_breakdown_metrics.title')}
            >
              <ParityMetrics atsCompanyId={atsCompanyId} jobs={jobsForAccess} />
            </Tabs.Tab>
          </Tabs>
        </MetricsFiltersProvider>
      )}
    </ResponsivePage.Body>
  )
}

export default InsightsPage
